module.exports = __webpack_public_path__ + "img/weavr-logo.5eee4221.svg";